import { APIClient } from '@frontend/api-utils';

export class ItsmeClient extends APIClient {
    public static readonly endpoint = '/itsme-api/v1';

    public static async discover(): Promise<void> {
        const res = await this.fetch(`${this.endpoint}/discover`);
        return await this.handleVoidResponse(res);
    }
}
